import { render, staticRenderFns } from "./SolutionCard.vue?vue&type=template&id=59ffa99b&scoped=true&"
import script from "./SolutionCard.vue?vue&type=script&lang=ts&"
export * from "./SolutionCard.vue?vue&type=script&lang=ts&"
import style0 from "./SolutionCard.vue?vue&type=style&index=0&id=59ffa99b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ffa99b",
  null
  
)

export default component.exports